import { ReactNode } from 'react';

import { Paragraph, TTranslator, WorkerIcon } from '@smartshell/ui-kit';

import { TLocalesKeys } from 'localization';
import { ELogType } from 'types';

import s from '../EventLogsTable.module.scss';

export const getGuest = (
  t: TTranslator<TLocalesKeys>,
  type: ELogType,
  isObject: boolean
): ReactNode => {
  switch (type) {
    case ELogType.BOOKING_CANCELED:
    case ELogType.BOOKING_CREATED:
    case ELogType.PAYMENT_REFUND:
    case ELogType.POST_PAYMENT_CANCELED:
      return isObject ? (
        <div className={s.guest}>
          <WorkerIcon size="s" />
          <Paragraph>{t('client.guest')}</Paragraph>
        </div>
      ) : null;
    case ELogType.CLIENT_SESSION_FINISHED:
    case ELogType.CLIENT_SESSION_PROLONGED:
    case ELogType.CLIENT_SESSION_STARTED:
    case ELogType.CLUB_COMMENT_CREATED:
    case ELogType.HOST_ADMIN_CALLED:
      return !isObject ? (
        <div className={s.guest}>
          <WorkerIcon size="s" />
          <Paragraph>{t('client.guest')}</Paragraph>
        </div>
      ) : null;
    default:
      return null;
  }
};
